import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from "yup";

import {clearMessage, setMessage} from "../slices/message";
import {LOCALES} from "../i18n/locales";
import {messages} from "../i18n/messages";
import {Navigate} from "react-router-dom";
import userService from "../services/user.service";
import Select from "react-select";

const RegisterClient = () => {
  const [successful, setSuccessful] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { user: currentUser } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);
  const [postzip, setPostzip] = useState("Post Code");
  const [country, setCountry] = useState("");
  const [provstate, setProvstate] = useState("Province");
  const [province, setProvince] = useState("");
  const [countries, setCountries] = useState([]);
  const [pz, setPz] = useState();
  const [postCode, setPostCode] = useState("");
  const dispatch = useDispatch();

  const [initialValues, setInitialValues] = useState({
    clientName: "",
    phone: "",
    email: "",
    address1: "",
    address2: "",
    city: "",
    province: province || "",
    postCode: postCode || "",
    country: country || "",
    contactFirstName: "",
    contactLastName: "",
    clientAccount: ""
  });


  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  useEffect(() => {
    setIsLoading(true);
    userService.getCpz().then(
        (response) => {
          setCountries(response.data.countries);
          setPz(response.data.ps);
          setInitialValues({...initialValues, "country": response.data.countries[0], "province": response.data.ps[response.data.countries[0]][0]})
          setIsLoading(false);
        },
        (error) => {
          const _content =
              (error.response &&
                  error.response.data) ||
              error.message ||
              error.toString();
          console.log(error);
          setMessage(_content);
          setIsLoading(false);
        }
    );
  }, []);

  useEffect(() => {
    if (countries && countries.length > 0) {
      setCountry(countries[0]);
      setPostzip(countries[0] === "CAN" ? "Post Code" : "Zip Code");
      setProvstate(countries[0] === "CAN" ? "Province" : "State");
      setProvince(pz[countries[0]][0].code);
    }
  }, [countries, pz]);

  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const phoneReg = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
  const usZipReg = /^\d{5}(-\d{4})?$/;
  const caPostReg = /[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i


  const validationSchema = Yup.object().shape({
    clientName: Yup.string().required(messages[LOCALES.ENGLISH].field_required),
    phone: Yup.string().required(messages[LOCALES.ENGLISH].field_required)
        .matches(phoneReg, messages[LOCALES.ENGLISH].invalid_phone),
    email: Yup.string()
        .email(messages[LOCALES.ENGLISH].invalid_email)
        .required(messages[LOCALES.ENGLISH].field_required),
    address1: Yup.string().required(messages[LOCALES.ENGLISH].field_required),
    city: Yup.string().required(messages[LOCALES.ENGLISH].field_required),
    contactFirstName: Yup.string().required(messages[LOCALES.ENGLISH].field_required),
    contactLastName: Yup.string().required(messages[LOCALES.ENGLISH].field_required),
    clientAccount: Yup.string()
        .email(messages[LOCALES.ENGLISH].invalid_email)
        .required(messages[LOCALES.ENGLISH].field_required),

  });

  const handleRegisterClient = (formValue) => {
    const { clientName, phone, email, address1, address2, city, postCode, contactFirstName, contactLastName, clientAccount } = formValue;

    setSuccessful(false);
    setIsLoading(true);

    dispatch(userService.registerClient({ clientName, phone, email, address1, address2, city, province, postCode, country, contactFirstName, contactLastName, clientAccount }))
      .unwrap()
      .then(() => {

        setSuccessful(true);
        setIsLoading(false);
      })
      .catch(() => {
        setSuccessful(false);
        setIsLoading(false);
      });
  };

  const handleSelectionCountry = (event) => {
    setPostzip(event.target.value === "CAN" ? "Post Code" : "Zip Code");
    setProvstate(event.target.value === "CAN" ? "Province" : "State");
    setCountry(event.target.value);
    setProvince(pz[event.target.value][0].code);
  }

  const handleSelectionProv = (event) => {
    setProvince(event.target.value);
  }

  const validatePZ = (value) => {
    let error;
    if (!value) {
      error = "Required";
    } else if (country === "CAN") {
      if (!caPostReg.test(value)) {
        error = messages[LOCALES.ENGLISH].invalid_postcode;
      }
    } else if (country === "USA") {
      if (!usZipReg.test(value)) {
        error = messages[LOCALES.ENGLISH].invalid_zipcode;
      }
    }
    return error;
  }

  const validateClientAccount = (value) => {
    let error;
    if (!value) {
      error = "Required";
    } else if (value === currentUser.username) {
      error = "Client Account cannot be the same as OWNER account.";
    }
    return error;
  }

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: '12px',
      padding: '0.1rem',
      border: '0',
      backgroundColor: '#f8f9fa',
      boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(79, 70, 229, 0.2)' : 'none',
      borderColor: state.isFocused ? 'rgba(79, 70, 229, 0.5)' : 'transparent',
      minHeight: '48px',
      fontSize: '1rem'
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '12px',
      border: '1px solid rgba(226, 232, 240, 0.8)',
      boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
      zIndex: 9999,
      minWidth: 'max-content'
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#4f46e5' : state.isFocused ? 'rgba(79, 70, 229, 0.05)' : 'white',
      color: state.isSelected ? 'white' : '#0f172a',
      cursor: 'pointer',
      padding: '0.6rem 1.2rem',
    })
  };

  return (
    <div className="container-fluid d-flex flex-column justify-content-center align-items-center py-5" style={{ background: 'var(--bg-gradient)', minHeight: 'calc(100vh - 76px)' }}>
      <div className="card border-0 shadow-lg" style={{ borderRadius: '24px', width: '100%', maxWidth: '600px', overflow: 'hidden' }}>
        <div className="card-body p-4 p-md-5">
          <div className="text-center mb-4">
            <div className="d-inline-flex align-items-center justify-content-center bg-primary bg-opacity-10 rounded-circle mb-3" style={{ width: '64px', height: '64px' }}>
              <i className="bi bi-building-add text-primary fs-2"></i>
            </div>
            <h2 className="fw-bold mb-0" style={{ color: 'var(--text-dark)' }}>Register New Client</h2>
          </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleRegisterClient}
        >
          {({ values, setFieldValue, handleSubmit, isSubmitting }) => (
          <Form>
            {!successful && (
              <div className="d-flex flex-column gap-3">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label htmlFor="clientName" className="text-muted small fw-bold mb-1">Name</label>
                    <Field name="clientName" type="input" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} />
                    <ErrorMessage name="clientName" component="div" className="text-danger small mt-1 fw-medium" />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="phone" className="text-muted small fw-bold mb-1">Phone</label>
                    <Field name="phone" type="input" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} />
                    <ErrorMessage name="phone" component="div" className="text-danger small mt-1 fw-medium" />
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-md-6">
                    <label htmlFor="address1" className="text-muted small fw-bold mb-1">Address 1</label>
                    <Field name="address1" type="input" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} />
                    <ErrorMessage name="address1" component="div" className="text-danger small mt-1 fw-medium" />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="address2" className="text-muted small fw-bold mb-1">Address 2</label>
                    <Field name="address2" type="input" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} />
                    <ErrorMessage name="address2" component="div" className="text-danger small mt-1 fw-medium" />
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-md-4">
                    <label htmlFor="city" className="text-muted small fw-bold mb-1">City</label>
                    <Field name="city" type="input" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} />
                    <ErrorMessage name="city" component="div" className="text-danger small mt-1 fw-medium" />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="country" className="text-muted small fw-bold mb-1">Country</label>
                    <Select
                        name="country"
                        options={countries ? countries.map(c => ({ value: c, label: c })) : []}
                        value={country ? { value: country, label: country } : null}
                        styles={customSelectStyles}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        onChange={(selectedOption) => {
                          const val = selectedOption ? selectedOption.value : "";
                          setFieldValue("country", val);
                          handleSelectionCountry({ target: { value: val } });
                        }}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="province" className="text-muted small fw-bold mb-1">{provstate || '\u00A0'}</label>
                    <Select
                        name="province"
                        options={pz && pz[country] ? pz[country].map(p => ({ value: p.code, label: p.name })) : []}
                        value={province && pz && pz[country] ? { value: province, label: pz[country].find(p => p.code === province)?.name || province } : null}
                        styles={customSelectStyles}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        onChange={(selectedOption) => {
                          const val = selectedOption ? selectedOption.value : "";
                          setFieldValue("province", val);
                          handleSelectionProv({ target: { value: val } });
                        }}
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="postCode" className="text-muted small fw-bold mb-1">{postzip}</label>
                  <Field name="postCode" type="input" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} validate={validatePZ} />
                  <ErrorMessage name="postCode" component="div" className="text-danger small mt-1 fw-medium" />
                </div>

                <div className="row g-3">
                  <div className="col-md-6">
                    <label htmlFor="contactFirstName" className="text-muted small fw-bold mb-1">Contact First Name</label>
                    <Field name="contactFirstName" type="input" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} />
                    <ErrorMessage name="contactFirstName" component="div" className="text-danger small mt-1 fw-medium" />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="contactLastName" className="text-muted small fw-bold mb-1">Contact Last Name</label>
                    <Field name="contactLastName" type="input" className="form-control form-control-lg bg-light border-0" style={{ fontSize: '1rem' }} />
                    <ErrorMessage name="contactLastName" component="div" className="text-danger small mt-1 fw-medium" />
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-md-6">
                    <label htmlFor="email" className="text-muted small fw-bold mb-1">Email</label>
                    <Field
                        name="email"
                        type="email"
                        className="form-control form-control-lg bg-light border-0"
                        style={{ fontSize: '1rem' }}
                        onBlur={(event) => {
                          if (event.target.value !== currentUser.username) {
                            setFieldValue("clientAccount", event.target.value.toLowerCase());
                          }
                        }}
                    />
                    <ErrorMessage name="email" component="div" className="text-danger small mt-1 fw-medium" />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="clientAccount" className="text-muted small fw-bold mb-1">Client Account</label>
                    <Field
                        name="clientAccount"
                        type="email"
                        className="form-control form-control-lg bg-light border-0"
                        style={{ fontSize: '1rem' }}
                        validate={validateClientAccount}
                    />
                    <ErrorMessage name="clientAccount" component="div" className="text-danger small mt-1 fw-medium" />
                  </div>
                </div>

                <button type="submit" className="btn-premium w-100 rounded-pill py-2 mt-3" disabled={isLoading}>
                  {isLoading ? (
                      <span className="spinner-border spinner-border-sm me-2"></span>
                  ) : (
                      <i className="bi bi-building-add me-2"></i>
                  )}
                  <span className="fw-bold">Register Client</span>
                </button>
              </div>
            )}
          </Form>
              )}
        </Formik>
        </div>
      </div>

      {message && (
        <div className="mt-4 w-100" style={{ maxWidth: '600px' }}>
          <div
            className={`alert ${successful ? "alert-success" : "alert-danger"} border-0 shadow-sm rounded-3 d-flex align-items-center`}
            role="alert"
          >
            <i className={`bi ${successful ? "bi-check-circle-fill" : "bi-exclamation-triangle-fill"} me-2 fs-5`}></i>
            <div>{message}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisterClient;
